import Cookies from 'js-cookie';

const getDomain = window.location.hostname;
const domain = `.${getDomain}`;

export const setCookie = (name: string, value: string, expires?: number) => {
  //? expires => number of days
  Cookies.set(name, value, {
    expires,
    secure: process.env.NODE_ENV === 'development' ? false : true, // Can be transmitted over HTTPS
    sameSite: 'Strict', // Prevent CSRF
    domain, // Ensures the cookie is available on subdomains
  });
};

export const getCookie = (name: string) => {
  return Cookies.get(name);
};

export const removeCookie = (name: string) => {
  Cookies.remove(name, { domain }); // Ensure cookie removal applies to the domain
};
